<div class="create-quote-header row mx-0">
  <h1 class="col-auto noselect">Create Quote</h1>
</div>

<!-- Stepper -->
<div class="stepper noselect">
  <ng-container *ngFor="let step of steps; let i = index">
    <div class="step"
         [class.active]="currentStep === i + 1"
         [class.complete]="currentStep > i + 1"
         [class.clickable]="currentStep > i + 1"
         (click)="goToStep(i + 1)">
      <div class="step-number">
        <span *ngIf="currentStep <= i + 1">{{ i + 1 }}</span>
        <span *ngIf="currentStep > i + 1" class="fa-solid fa-check"></span>
      </div>
      <div class="step-label">{{ step }}</div>
    </div>
    <div *ngIf="i < steps.length - 1" class="step-connector" [class.complete]="currentStep > i + 1"></div>
  </ng-container>
</div>

<div class="step-content">

  <!-- ============= STEP 1: CUSTOMER ============= -->
  <form *ngIf="currentStep === 1" [formGroup]="customerForm" class="row justify-content-center">
    <!-- New Customer toggle -->
    <div class="col-12 col-md-6 col-lg-4">
      <label class="form-label d-block noselect">New Customer</label>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" id="newCustomerNo" formControlName="newCustomer" [value]="false">
        <label class="form-check-label" for="newCustomerNo">No</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" id="newCustomerYes" formControlName="newCustomer" [value]="true">
        <label class="form-check-label" for="newCustomerYes">Yes</label>
      </div>
    </div>
    <div class="d-100"></div>

    <!-- Existing customer selection -->
    <div *ngIf="!isNewCustomer" class="col-12 col-md-6 col-lg-4 mt-2">
      <label for="customerSelect" class="form-label noselect">Customer</label>
      <select id="customerSelect" class="form-select" formControlName="selectedCustomer">
        <option value="" disabled>Select a customer</option>
        <option *ngFor="let customer of customers" [value]="customer.userId">
          {{ getCustomerDisplayName(customer) }}
        </option>
      </select>
    </div>

    <!-- New customer details (registration form without passwords) -->
    <ng-container *ngIf="isNewCustomer">
      <div class="col-12 col-md-6 col-lg-4 mt-2">
        <app-input [form]="customerForm" formGroupName="firstName" placeHolder="First Name"></app-input>
      </div>
      <div class="d-100"></div>
      <div class="col-12 col-md-6 col-lg-4">
        <app-input [form]="customerForm" formGroupName="lastName" placeHolder="Last Name"></app-input>
      </div>
      <div class="d-100"></div>
      <div class="col-12 col-md-6 col-lg-4">
        <app-input [form]="customerForm" formGroupName="phone" placeHolder="Phone Number" inputType="tel"></app-input>
      </div>
      <div class="d-100"></div>
      <div class="col-12 col-md-6 col-lg-4">
        <app-input [form]="customerForm" formGroupName="email" placeHolder="E-mail"></app-input>
      </div>
    </ng-container>
  </form>

  <!-- ============= STEP 2: VEHICLES ============= -->
  <div *ngIf="currentStep === 2">
    <div class="step-heading noselect">
      <h2>Vehicles for {{ selectedCustomer ? selectedCustomer.firstName + ' ' + selectedCustomer.lastName : 'customer' }}</h2>
      <p class="text-muted">Select the vehicles this quote covers. A quote can include more than one vehicle.</p>
    </div>

    <div class="vehicle-grid">
      <div *ngFor="let vehicle of vehicles"
           class="vehicle-card noselect"
           [class.selected]="isVehicleSelected(vehicle.VehicleId)"
           (click)="toggleVehicle(vehicle.VehicleId)">
        <div class="vehicle-check">
          <span class="fa-solid fa-check"></span>
        </div>
        <div class="vehicle-name">{{ getVehicleDisplayName(vehicle) }}</div>
        <div *ngIf="vehicle.Vin" class="vehicle-vin">VIN: {{ vehicle.Vin }}</div>
      </div>

      <button type="button" class="vehicle-card add-vehicle-card noselect" (click)="openAddVehicleModal()">
        <span class="fa-solid fa-plus"></span>
        <span>Add New Vehicle</span>
      </button>
    </div>

    <p *ngIf="vehicles.length === 0" class="text-muted noselect">
      This customer has no vehicles on file yet. Add one to continue.
    </p>
  </div>

  <!-- ============= STEP 3: WORK ITEMS ============= -->
  <div *ngIf="currentStep === 3" class="row justify-content-center">
    <div class="col-12 col-lg-5">
      <div class="step-heading noselect">
        <h2>Add Work Items</h2>
        <p class="text-muted">Optional — work items can also be added later during mechanic review.</p>
      </div>

      <form [formGroup]="workItemForm" (ngSubmit)="addWorkItem()">
        <div *ngIf="selectedVehicleIds.length > 1" class="mb-2">
          <label for="workItemVehicleSelect" class="form-label noselect">Vehicle</label>
          <select id="workItemVehicleSelect" class="form-select" formControlName="vehicleId">
            <option *ngFor="let vehicle of selectedVehicles" [value]="vehicle.VehicleId">
              {{ getVehicleDisplayName(vehicle) }}
            </option>
          </select>
        </div>

        <app-work-item-form-fields [form]="workItemForm" [mechanics]="mechanics"></app-work-item-form-fields>

        <button class="btn btn-outline-primary w-100" type="submit">
          <span class="fa-solid fa-plus me-1"></span> Add Work Item
        </button>
      </form>
    </div>

    <div class="col-12 col-lg-5 mt-4 mt-lg-0">
      <div class="step-heading noselect">
        <h2>Staged Work Items</h2>
        <p *ngIf="workItems.length === 0" class="text-muted">No work items added yet.</p>
      </div>

      <div *ngFor="let vehicle of selectedVehicles" class="work-item-group">
        <ng-container *ngIf="workItemsForVehicle(vehicle.VehicleId).length > 0">
          <h3 class="work-item-vehicle noselect">{{ getVehicleDisplayName(vehicle) }}</h3>
          <div *ngFor="let workItem of workItemsForVehicle(vehicle.VehicleId)" class="work-item-card">
            <div class="work-item-body">
              <div class="work-item-title">{{ workItem.title }}</div>
              <div class="work-item-detail noselect">
                <span class="fa-solid fa-user-gear me-1"></span>{{ getMechanicDisplayName(workItem.empUserId) }}
                <span *ngIf="workItem.miles !== null" class="ms-2">{{ workItem.miles | number }} mi</span>
                <span *ngIf="workItem.shopHours !== null" class="ms-2">{{ workItem.shopHours }} hr</span>
                <span *ngIf="workItem.partsPricing !== null" class="ms-2">{{ workItem.partsPricing | currency }}</span>
                <span *ngIf="workItem.flatFee !== null" class="ms-2">
                  {{ workItem.flatFee | currency }} flat ({{ workItem.flatFeeTaxable ? 'taxable' : 'no tax' }})
                </span>
              </div>
              <div *ngIf="workItem.notes" class="work-item-notes">{{ workItem.notes }}</div>
            </div>
            <button type="button" class="btn-remove-work-item" (click)="removeWorkItem(workItem)" title="Remove work item">
              <span class="fa-solid fa-xmark"></span>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- ============= STEP 4: REVIEW ============= -->
  <div *ngIf="currentStep === 4" class="row justify-content-center">
    <div class="col-12 col-lg-8">
      <div class="step-heading noselect">
        <h2>Review Quote</h2>
      </div>

      <div class="review-section">
        <h3 class="noselect">Customer</h3>
        <p *ngIf="selectedCustomer">{{ getCustomerDisplayName(selectedCustomer) }}</p>
      </div>

      <div class="review-section">
        <h3 class="noselect">Vehicles &amp; Work Items</h3>
        <div *ngFor="let vehicle of selectedVehicles" class="review-vehicle">
          <div class="review-vehicle-name">
            <span class="fa-solid fa-car me-2"></span>{{ getVehicleDisplayName(vehicle) }}
            <span *ngIf="vehicle.Vin" class="review-vin">VIN: {{ vehicle.Vin }}</span>
          </div>
          <ul class="review-work-items">
            <li *ngFor="let workItem of workItemsForVehicle(vehicle.VehicleId)">
              <span class="review-work-item-title">{{ workItem.title }}</span>
              — {{ getMechanicDisplayName(workItem.empUserId) }}
              <span *ngIf="workItem.flatFee === null && workItem.partsPricing !== null">({{ workItem.partsPricing | currency }} parts)</span>
              <span *ngIf="workItem.flatFee !== null">({{ workItem.flatFee | currency }} flat fee)</span>
            </li>
            <li *ngIf="workItemsForVehicle(vehicle.VehicleId).length === 0" class="text-muted">
              No work items for this vehicle.
            </li>
          </ul>
        </div>
      </div>

      <div class="review-section">
        <h3 class="noselect">Estimated Shop Time</h3>
        <p>{{ totalShopHours > 0 ? formatShopTime(totalShopHours) : 'No shop time estimated' }}</p>
      </div>

      <div class="review-section">
        <h3 class="noselect">Estimated Charges</h3>
        <p class="mb-0">Labor: {{ estimatedLaborTotal | currency }}</p>
        <p class="mb-0">Parts: {{ estimatedPartsTotal | currency }}</p>
        <p *ngIf="estimatedFlatFeeTotal > 0" class="mb-0">Flat fees: {{ estimatedFlatFeeTotal | currency }}</p>
        <p class="mb-0">Sub-Total: {{ estimatedSubtotal | currency }}</p>
        <p class="mb-0">Tax: {{ estimatedTax | currency }}</p>
        <p class="fw-bold">Total: {{ estimatedTotal | currency }}</p>
      </div>
    </div>
  </div>

  <!-- ============= NAVIGATION ============= -->
  <div class="row justify-content-center mt-4 wizard-nav">
    <div class="col-6 col-md-3 col-lg-2" *ngIf="currentStep > 1">
      <button type="button" class="btn btn-secondary w-100" (click)="back()" [disabled]="isSubmitting">
        Back
      </button>
    </div>
    <div class="col-6 col-md-3 col-lg-2" *ngIf="currentStep < 4">
      <button type="button" class="btn btn-primary w-100" (click)="next()">
        {{ currentStep === 1 && isNewCustomer ? 'Create Customer' : 'Next' }}
      </button>
    </div>
    <div class="col-6 col-md-3 col-lg-2" *ngIf="currentStep === 4">
      <button type="button" class="btn btn-primary w-100" (click)="submitQuote()" [disabled]="isSubmitting">
        {{ isSubmitting ? 'Creating...' : 'Create Quote' }}
      </button>
    </div>
  </div>

</div>
